import React from "react"

const Search = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M13.634 13.1496C13.6065 13.1706 13.5799 13.194 13.5541 13.2198C13.5283 13.2456 13.5057 13.2715 13.4839 13.2997C12.4689 14.2784 11.0883 14.8795 9.56661 14.8795C8.00696 14.8795 6.59577 14.2486 5.57267 13.2255C4.54958 12.2024 3.91861 10.7912 3.91861 9.23153C3.91861 7.67188 4.54958 6.26068 5.57267 5.23759C6.59577 4.21449 8.00696 3.58353 9.56661 3.58353C11.1263 3.58353 12.5375 4.21449 13.5606 5.23759C14.5836 6.26068 15.2146 7.67188 15.2146 9.23153C15.2146 10.7533 14.6135 12.1338 13.634 13.1496ZM18.2056 16.7297L15.2404 13.7645C16.2337 12.5219 16.8283 10.9461 16.8283 9.23153C16.8283 7.22649 16.015 5.41026 14.7014 4.09669C13.3879 2.78313 11.5717 1.96982 9.56661 1.96982C7.56157 1.96982 5.74534 2.78313 4.43178 4.09669C3.11821 5.41026 2.3049 7.22649 2.3049 9.23153C2.3049 11.2366 3.11821 13.0528 4.43178 14.3664C5.74534 15.6799 7.56157 16.4932 9.56661 16.4932C11.2812 16.4932 12.857 15.8986 14.0995 14.9053L17.0647 17.8705C17.3802 18.186 17.891 18.186 18.2056 17.8705C18.5203 17.5551 18.5211 17.0443 18.2056 16.7297Z"
        fill="white"
      />
    </svg>
  )
}

export default Search
